export default __webpack_public_path__ + "static/media/financial-report.c75f4ca7.svg";